module.exports = __webpack_public_path__ + "static/media/binary-2bit.abff4f26.gif";